export enum Step {
  DESCRIPTION = 1,
  CONTACT_PREFERENCES = 2,
  CONFIRMATION = 3,
}

export enum ContactMethod {
  PHONE = "phone",
  EMAIL = "email",
}

export interface HelpDrawerProps {
  open: boolean
  onClose: () => void
}

export interface DescriptionStepProps {
  description: string
  handleDescriptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  uploadedFiles: FileList | undefined
  setUploadedFiles: React.Dispatch<React.SetStateAction<FileList | undefined>>
  setFileUploadErrors: React.Dispatch<React.SetStateAction<string[]>>
  isDescriptionValid: boolean
}

export interface ContactPreferencesStepProps {
  existingPhoneNumber: string
  existingEmail: string
  contactPreferences: ContactMethod
  setContactPreferences: React.Dispatch<React.SetStateAction<ContactMethod>>
  contactInfo: string
  setContactInfo: React.Dispatch<React.SetStateAction<string>>
  setIsContactInfoValid: React.Dispatch<React.SetStateAction<boolean | null>>
  resetValidationError: () => void
  isContactInfoValid: boolean | null
  showContactInfoForm: boolean
  setShowContactInfoForm: React.Dispatch<React.SetStateAction<boolean>>
  handleContactInfoChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export interface ConfirmationStepProps {
  handleFinish: () => void
}

export interface ContactMethodCardProps {
  method: ContactMethod
  title: string
  description: string
  buttonText: string
  isSelected: boolean
  isRecommended?: boolean
  showContactInfoForm: boolean
  hours?: string
  onSelect: (method: ContactMethod) => void
  onRequest: () => void
}

export interface ContactInfoFormProps {
  title: string
  existingInfo: string
  existingTemplate: string
  missingMessage: string
  label: string
  error: boolean
  errorMessage: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export interface UseHelpDrawerReturn {
  state: {
    description: string
    uploadedFiles: FileList | undefined
    currentStep: Step
    isDescriptionValid: boolean
    validationError: string | null
    contactPreferences: ContactMethod
    existingPhoneNumber: string
    existingEmail: string
    contactInfo: string
    isContactInfoValid: boolean | null
    showCloseConfirmation: boolean
    fileUploadErrors: string[]
    showContactInfoForm: boolean
    isSendingFeedback: boolean
  }
  handlers: {
    handleContactInfoChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    handleDescriptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    handleSubmit: () => void
    handleNextStep: () => void
    handleBackStep: () => void
    handleCloseAttempt: () => void
    handleCancelClose: () => void
    handleConfirmClose: () => void
    resetValidationError: () => void
    setUploadedFiles: React.Dispatch<React.SetStateAction<FileList | undefined>>
    setFileUploadErrors: React.Dispatch<React.SetStateAction<string[]>>
    setContactPreferences: React.Dispatch<React.SetStateAction<ContactMethod>>
    setContactInfo: React.Dispatch<React.SetStateAction<string>>
    setIsContactInfoValid: React.Dispatch<React.SetStateAction<boolean | null>>
    setShowContactInfoForm: React.Dispatch<React.SetStateAction<boolean>>
    closeAndReset: () => void
  }
}
